import React from "react";
import MUIAutocomplete from "@mui/material/Autocomplete";
import MUICircularProgress from "@mui/material/CircularProgress";
import { getClassName } from "@sscs/utils";
import TextField from "../TextField/TextField";
import styles from "./autocomplete.module.scss";
const clearIndicator = (isAlwaysVisible) => {
    if (isAlwaysVisible === undefined)
        return undefined;
    return isAlwaysVisible ? "always" : "hover";
};
function Autocomplete({ label, placeholder, inputProps, isClearAlwaysVisible, className, ...props }) {
    return (React.createElement(MUIAutocomplete, { loadingText: "Loading...", className: className, "data-clear-indicator": clearIndicator(isClearAlwaysVisible), renderInput: (params) => (React.createElement(TextField, { ...params, className: styles["text-input"], label: label, placeholder: placeholder, slotProps: {
                ...params.slotProps,
                input: {
                    ...params.slotProps.input,
                    endAdornment: (React.createElement(React.Fragment, null,
                        React.createElement(MUICircularProgress, { color: "inherit", size: 20, sx: { visibility: props.loading ? "visible" : "hidden" } }),
                        params.slotProps.input.endAdornment)),
                },
                htmlInput: {
                    ...params.slotProps.htmlInput,
                    ...inputProps,
                    className: getClassName(styles["text-input"], inputProps === null || inputProps === void 0 ? void 0 : inputProps.className, params.slotProps.htmlInput.className),
                },
            } })), ...props }));
}
export default Autocomplete;
//# sourceMappingURL=Autocomplete.js.map